<div class="answer">
    {{ text }}
</div>